import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { missingEnvKeys } from "./config/env";
import { renderMissingEnvScreen } from "./config/missingEnvScreen";
import { applyDeviceConsent } from "./lib/deviceConsent";
import { bookPdfCache } from "./lib/bookPdfCache";
import { i18nReady } from "./i18n";

const root = document.getElementById("root")!;

if (missingEnvKeys.length > 0) {
  renderMissingEnvScreen(root, missingEnvKeys);
} else {
  // Sentry starts only once this device ACCEPTED crash_reports (storage banner / Settings → Privacy).
  applyDeviceConsent();
  // the previous build's plain (unencrypted) book cache goes at start, whatever this browser supports
  void bookPdfCache.migrate();
  // i18n resources for the active language load lazily (see src/i18n) —
  // wait for them so the first render already has real translations.
  i18nReady.then(() => {
    createRoot(root).render(
      <StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </StrictMode>,
    );
  });
}
